import { render, staticRenderFns } from "./NewDetails.vue?vue&type=template&id=4b967fae"
import script from "./NewDetails.vue?vue&type=script&lang=js"
export * from "./NewDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports